import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function PortfolioCard({ project, index = 0, onOpen }) {
  return (
    <motion.article
      data-testid={`portfolio-card-${project.id}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.02] backdrop-blur-md cursor-pointer"
      onClick={() => onOpen?.(project)}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <div
          className={`absolute inset-0 bg-gradient-to-br ${project.accent} opacity-70 mix-blend-screen`}
          aria-hidden
        />
        <img
          src={project.image}
          alt={project.title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          <span
            data-testid={`portfolio-card-tech-${project.id}`}
            className="rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-white/90 text-xs px-3 py-1"
          >
            {project.tech}
          </span>
          {project.industry && (
            <span className="rounded-full bg-black/30 backdrop-blur-md border border-white/10 text-zinc-300 text-xs px-3 py-1">
              {project.industry}
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7 flex items-end justify-between">
          <div>
            <h3 className="font-display text-xl md:text-2xl text-white tracking-tight">
              {project.title}
            </h3>
          </div>
          <span className="w-11 h-11 grid place-items-center rounded-full bg-white/10 border border-white/15 backdrop-blur-md text-white group-hover:bg-blue-500 group-hover:border-blue-400 transition-colors">
            <ArrowUpRight size={18} />
          </span>
        </div>
      </div>
    </motion.article>
  );
}
